import React from 'react';
import { useSelector } from 'react-redux';
import { isCharedi } from '../../../utils/utils';
import Popup from '../../ui/popup/Popup';
import HeaderPopup from '../../ui/popup/headerPopup/HeaderPopup';
import ContentsPopup from '../../ui/popup/contentPopup/ContentPopup';
import restCharacter from '../../../assets/breakPopupImg.png';
import classes from './BreakPopup.module.css';

const BreakPopup = ({ onClose }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <Popup close={onClose} dropClass={classes.breakPopup} accessibilityDescription={texts.competitionOnBreak}>
            <HeaderPopup title={texts.competitionOnBreak} className={classes.header} />
            <ContentsPopup className={classes.popupContent}>

                <div className={classes.content}>
                    <div className={classes.restCharacter}>
                        { isCharedi()?<div className={classes.restCharacterImg}></div>:
                        <img src={restCharacter} alt="Rest character" className={classes.illustrationImg} />
                    }
                    </div>
                    <p className={classes.text}> {texts.competitionBreakMessageAfterEnded}</p>
                </div>

            </ContentsPopup>
            <div className={classes.buttonWrapper}>
                <button onClick={onClose} className={classes.button}>
                    {texts.btnAfterCompetitionBreak}
                </button>
            </div>
        </Popup>
    );
};

export default BreakPopup;

